export default {
  getResults: (state) => state.searchResults,
  showSearch: (state) => state.showSearch,
  getSearchbarWidth: (state) => state.searchbarWidth,
};
